import styled, { css } from "styled-components";

export const Quiz = ({ quiz, selectAnswer, hasCheckedAnswers }) => (
  <div className="quiz">
    <div>{quiz.question}</div>
    <div className="answers">
      {quiz.answers.map(({ id, text, isSelected }) => (
        <Button
          isSelected={isSelected}
          isChecked={hasCheckedAnswers}
          isCorrect={quiz.correctAnswer === text}
          key={id}
          onClick={() => selectAnswer(id)}
        >
          {text}
        </Button>
      ))}
    </div>
  </div>
);

const Button = styled.button`
  background: ${(props) => (props.isSelected ? "#d6dbf5" : " #f5f7fb")};
  color: #293264;
  font-family: "Inter", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;
  width: fit-content;
  min-width: 65px;
  padding: 5px 10px;
  border: ${(props) =>
    props.isSelected ? "1px solid #d6dbf5" : "1px solid #4d5b9e"};
  border-radius: 8px;
  cursor: pointer;

  ${(props) =>
    props.isChecked &&
    css`
      opacity: ${props.isCorrect ? "100%" : "50%"};
      background-color: ${props.isCorrect ? "#94d7a2" : "#f8bcbc"};
      border: ${props.isCorrect ? "1px solid #94d7a2" : "1px solid #f8bcbc"};
    `}
 @media screen and (max-width: 1024px) {
    .btn:hover {
      background-color: #4CAF50;
      cursor: pointer;
    }
`;

    /* end of Quiz component */
